__turbopack_context__.v({
  "root": "OutOfStockDisclaimer-module__mDTFAG__root",
});
